import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { type Destinatario } from '@framework/api-client/api/inquiries-compile/schemas/destinatario.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { useTranslation } from 'react-i18next';
import { CommunicationUserTypeTag } from '../CommunicationUserTypeTag.tsx';
import { CommunicationReadStateTag } from './CommunicationReadStateTag.tsx';
import { CommunicationRecipientStatusIcon } from './CommunicationRecipientStatusIcon.tsx';
import { UserName } from './UserName.tsx';
import { useNormalizedCommunicationUserType } from './useNormalizedCommunicationUserType.ts';

interface CommunicationRecipientProps {
  recipient: Destinatario | undefined;
  communication: ComunicazioneDTO | undefined;
  compactView?: boolean;
}

/**
 * Singolo destinatario comunicazione
 */
export function CommunicationRecipient(props: CommunicationRecipientProps) {
  const { recipient, communication, compactView } = props;
  const { t } = useTranslation();

  const normalizedCommunicationUserType = useNormalizedCommunicationUserType(
    recipient?.tipoDestinatarioEnum,
    recipient?.idProcedimento,
    // TODO: passare il Tipo Competenza Secondaria del destinatario // NOSONAR
    // quando il backend lo esporrà su Destinatario
    null,
  );

  if (!recipient) return null;

  return (
    <div key={recipient.id}>
      <UserName
        key={recipient.id}
        name={recipient.denominazione ?? 'N/A'}
        icon={<CommunicationRecipientStatusIcon recipient={recipient} />}
        tag={
          !compactView ? (
            <CommunicationUserTypeTag
              mini
              {...normalizedCommunicationUserType}
            />
          ) : undefined
        }
        hasProtocol={
          (!compactView &&
            communication?.tipoComunicazione?.flProtocollazione) ??
          false
        }
        sendDate={
          !compactView &&
          recipient.dataInvio && (
            <div>
              {t('communication-recipient.send-date', 'Data invio')}:{' '}
              <b>
                <ISODate date={recipient.dataInvio} format="DD/MM/YYYY" />
              </b>
            </div>
          )
        }
        registrationDate={
          !compactView &&
          recipient.dataRegistrazione && (
            <div>
              {t(
                'communication-recipient.registration-date',
                'Data protocollo',
              )}
              :{' '}
              <b>
                <ISODate
                  date={recipient.dataRegistrazione}
                  format="DD/MM/YYYY"
                />
              </b>
            </div>
          )
        }
        protocolNumber={
          !compactView &&
          recipient.numeroProtocollo && (
            <div>
              {t('communication-recipient.protocol-number', 'Protocollo')}:{' '}
              <b>{recipient.numeroProtocollo}</b>
            </div>
          )
        }
        readState={
          !compactView && <CommunicationReadStateTag recipient={recipient} />
        }
      />
    </div>
  );
}
